import React from "react";
import { MtApiResponse } from "../../utils/types";

interface MtExportButtonProps {
  data: MtApiResponse | undefined;
}

const MtExportButton: React.FC<MtExportButtonProps> = ({ data }) => {
  const exportToCSV = () => {
    if (!data?.data) return;

    const headers = ["Phone Number", "MO", "MT Response", "Network", "Created At"].join(",");
    const rows = data.data
      .map((row) =>
        [
          row.msisdn,
          `"${row.mo.replace(/"/g, '""')}"`,
          `"${row.mt_response.replace(/"/g, '""')}"`,
          row.network,
          new Date(row.created_at).toLocaleString(),
        ].join(",")
      )
      .join("\n");

    const csvContent = `data:text/csv;charset=utf-8,${headers}\n${rows}`;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "mt_table_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="p-4 flex justify-end">
      <button
        onClick={exportToCSV}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium text-sm sm:text-base"
      >
        Export to CSV
      </button>
    </div>
  );
};

export default MtExportButton;